//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { SwaggerException } from './SwaggerException';

export class Utilities
{
    /**
     * The messages of the errors thrown when an argument of a client method is missing or null.
     * Gathered here rather than repeated at every parameter of every operation.
     */
    public static readonly parameterErrors = {
        mustBeDefined: (parameterName: string): string =>
            `The parameter "${parameterName}" must be defined.`,
        mustBeDefinedAndNotNull: (parameterName: string): string =>
            `The parameter "${parameterName}" must be defined and cannot be null.`,
        cannotBeNull: (parameterName: string): string =>
            `The parameter "${parameterName}" cannot be null.`,
    };

    public static async processResponse<T>(
        response: Response,
        isFile: boolean,
        dateFields: string[],
    ): Promise<T> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status >= 200 && status < 300) {
            if (isFile) {
                const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
                const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
                return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers } as unknown as T; });
            }
            if (response && response.text) {
                return response.text().then((_responseText) => {
                    try {
                        const result: any = _responseText === '' ? null : JSON.parse(_responseText, (key, value) => {
                            if (value
                                && dateFields?.includes(key)
                                && (typeof value === 'string' || (Array.isArray(value) && value.every(i => typeof i === 'string'))) 
                                ) {
                               if (Array.isArray(value)) {
                                    return value.map(v => Utilities.ConvertToDate(v));
                                }
                                else {
                                    return Utilities.ConvertToDate(value);
                                }
                            }
                            return value;
                        }) as T;
                        return result;
                    } catch (error) {
                        return Promise.reject(new SwaggerException(error instanceof Error ? error.message : 'JSON.parse error', status, _responseText, _headers, null));
                    }
                });
            }
            else {
                return Promise.resolve<T>(<any>null);
            }
        }

        const errorMessage = status < 500 ? 'A server error occurred.' : 'An unexpected server error occurred.';

        if (response instanceof Error) {
        	return Promise.reject(new SwaggerException(response.message, status, response.message, _headers, null));
        }

        if (response && response.text) {
        	const responseText = await response.text();
        	return Promise.reject(new SwaggerException(errorMessage, status, responseText, _headers, null));
        }

        return Promise.resolve<T>(<any>null);
    }

    public static ConvertToDate (value: any) {
        const date = new Date(value);
        return isNaN(date.getTime()) ? value : date;
    }
}
